// @flow
import type {Element} from 'react'
import React, {Component} from 'react'
import {
  compose,
  forEach,
  isEmpty,
  last,
  prop,
  sortBy,
  toPairs,
  values,
} from 'ramda'

import SelectItem from '../SelectItem'
import SelectItemControls from '../SelectItemControls'
import type {Path, UpdateCallback} from '../../../types'

const sortByName = sortBy(compose(prop('displayName'), last))

const toSortedPairs = compose(sortByName, toPairs)

type Props = {
  id?: string,
  isReadonly: boolean,
  items: Object,
  onChange: UpdateCallback,
  path: Path,
  title: string,
  itemId?: Object => string,
  className?: string,
}

class SelectItems extends Component<Props> {
  static defaultProps: { isReadonly: boolean } = {
    isReadonly: false,
  }

  onClearAll: (() => void) = () => this.setAllSelected(false)

  onSelectAll: (() => void) = () => this.setAllSelected(true)

  setAllSelected(itemsSelectionState: boolean) {
    forEach((item) => item.setSelected(itemsSelectionState), values(this.props.items))
    this.props.onChange(this.props.path, this.props.items)
  }

  itemId: ((item: any) => ?string) = (item: Object): ?string => {
    if (this.props.itemId)
      return this.props.itemId(item)

    return null
  }

  render(): null | Element<"div"> {
    if (isEmpty(this.props.items))
      return null

    return (
      <div className={this.props.className}>
        <div className="refinery-select-items" id={this.props.id}>
          <div className="label refinery-select-items__label">
            {`${this.props.title}: `}
          </div>
          <div className="test-refinery-select-items__body refinery-select-items__body">
            {!this.props.isReadonly && (
              <SelectItemControls
                onClearAll={this.onClearAll}
                onSelectAll={this.onSelectAll}
              />
            )}
            <div className="refinery-select-items__checkboxes">
              {toSortedPairs(this.props.items).map(([databaseId, item]) => (
                <SelectItem
                  key={databaseId}
                  id={this.itemId(item)}
                  isReadonly={this.props.isReadonly}
                  item={item}
                  path={this.props.path.concat(databaseId)}
                  onChange={this.props.onChange}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SelectItems
